import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXPrivacyPolicy implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;

    }
    getPageClass():string{
        return "zidxPrivacyPolicyContainer";
    }
    render(){
        // console.log("privacy policy");
    }
}